import React, { Component } from 'react';
import { Layout, Statistic, Icon, Row, Col, Spin } from 'antd';
import '../../App.css';
import { connect } from 'react-redux';
import axios from 'axios';
import { defaults, Pie } from 'react-chartjs-2';

import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import { Constant } from '../../config';

import './Home.css';

const { Content } = Layout;
defaults.global.legend.position = 'bottom';

class Home extends Component {
  state = {
    loading: false,
    dataSource: {},
  }

  componentWillMount(){
    this.props.fetchMenuAction("home", "home")
    this.setState({loading: true})
  }

  async componentDidMount() {
    this.setState({
      loading: false,
      dataSource: await this._get(),
    })
  }

  setChartData = (d) => {
    if (typeof d.total !== "undefined")
      delete d.total

    let labels = []
    let data = []
    Object.keys(d).map((v, i) => {
      labels.push(
        v === "sent" || v === "confirm" ? "Success" : 
        v === "failed" ? "Failed" :
        v === "expired" ? "Expired" :
        v === "cancelled" ? "Cancelled" :
        v === "reject" ? "Reject" :
        v
      )
      data.push(d[v])
      return i
    });

    return {
      labels,
      datasets: [{
        data,
        backgroundColor: [
            '#00B300',
            '#FF6384',
            '#FFCE56',
            '#CECECE'
        ],
        hoverBackgroundColor: [
            '#00B300',
            '#FF6384',
            '#FFCE56',
            '#CECECE'
        ]
      }]
    }
  }

  _get = async () =>{
    let url = Constant.HOME_API
    let opt = {
      url,
      method: "GET",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(err) {
      resp = err.response
    }

    if (!resp.data){
      console.log(resp.data)
      return []
    }

    if (resp.data.error) {
      console.log(resp.data.error)
      return []
    }

    return resp.data
  }

  render(){
    if (typeof this.state.dataSource.member === "undefined")
      return ""

    const {member, outbound, verify, payment} = this.state.dataSource

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="Loading...">
          <Content
            style={{
              background: '#fff',
              padding: 24,
              margin: '16px 0',
              minHeight: 300,
            }}
          >
            <h2>Home</h2>
            <div className="is-desktop">
              <Row className="member-row">
                <Col span={6}>
                  <Statistic className="bg-success" title={<span><Icon type="user" /> Customer</span>} value={member.alive} />
                </Col>
                <Col span={6}>
                  <Statistic className="bg-warning" title={<span><Icon type="user" /> Blocked</span>} value={member.blocked} />
                </Col>
                <Col span={6}>
                  <Statistic className="bg-danger" title={<span><Icon type="user" /> Deleted</span>} value={member.deleted} />
                </Col>
                <Col span={6}>
                  <Statistic className="bg-secondary" title={<span><Icon type="user" /> Total</span>} value={member.total} />
                </Col>
              </Row>
              <Row className="chart-row">
                <Col span={8}>
                  <p>SMS</p>
                  <Pie data={this.setChartData(outbound)} />
                </Col>
                <Col span={8}>
                  <p>Verify</p>
                  <Pie data={this.setChartData(verify)} />
                </Col>
                <Col span={8}>
                  <p>Payment Transactions</p>
                  <Pie data={this.setChartData(payment)} />
                </Col>
              </Row>
            </div>

            <div className="is-mobile">
              <Row className="member-row">
                <Col span={12}><Statistic className="bg-success" title={<span><Icon type="user" /> Customer</span>} value={member.alive} /></Col>
                <Col span={12}><Statistic className="bg-warning" title={<span><Icon type="user" /> Blocked</span>} value={member.blocked} /></Col>
              </Row>
              <Row className="member-row">
                <Col span={12}><Statistic className="bg-danger" title={<span><Icon type="user" /> Deleted</span>} /></Col>
                <Col span={12}><Statistic className="bg-secondary" title={<span><Icon type="user" /> Total</span>} value={member.total} /></Col>
              </Row>
              <Row className="chart-row">
                <p>SMS</p>
                <Pie data={this.setChartData(outbound)} />
              </Row>
              <Row className="chart-row">
                <p>Verify</p>
                <Pie data={this.setChartData(verify)} />
              </Row>
              <Row className="chart-row">
                <p>Payment Transactions</p>
                <Pie data={this.setChartData(payment)} />
              </Row>
            </div>

          </Content>
        </Spin>
      </Layout>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey))
  }
}

export default connect(null, mapDispatchToProps)(Home)


// WEBPACK FOOTER //
// ./src/containers/Home/index.js